<script setup>
const { degree, isDisabled } = defineProps({
  degree: String | null,
  isDisabled: Boolean,
});

const emit = defineEmits(["onChange"]);

const isEdit = ref(false);
const selectedDegree = ref();
const { data: degrees } = useFetch("/api/degree");

const onUpdateDegree = (value) => {
  if (value) emit("onChange", value);
  isEdit.value = false;
};

onMounted(() => {
  selectedDegree.value = degree;
});
</script>

<template>
  <p v-if="isDisabled" class="text-sm font-normal text-gray-600 py-1">
    {{ degree }}
  </p>
  <Select
    v-else-if="isEdit"
    name="degree"
    v-model="selectedDegree"
    :options="degrees"
    @value-change="onUpdateDegree"
    id="degree"
    optionLabel="label"
    optionValue="value"
    placeholder="Select degree"
    class="w-full placeholder:text-xs lg:placeholder:text-sm text-[#4B5563] text-xs lg:text-sm"
  />
  <div
    v-else
    class="flex items-center gap-1 cursor-pointer"
    @click="isEdit = true"
  >
    <p
      v-if="degree"
      class="text-sm font-normal text-blue-500 hover:text-blue-600"
    >
      {{ degree }}
    </p>
    <p v-else class="text-sm">Select degree</p>

    <div class="flex w-6 h-6 items-center justify-center">
      <i class="pi pi-angle-down" />
    </div>
  </div>
</template>
